
const getters = {
  clazzList: state => state.clazzStandard.clazzList,
  fragmentList: state => state.clazzStandard.fragmentList,
  companyList: state => state.account.companyList,
  gradationList: state => state.account.gradationList,
  courseList: state => state.course.courseList,
  editQueue: state => state.knowledgeEdit.editQueue,
  deptList: state => state.dept.deptList,
}

export default getters
